export default __webpack_public_path__ + "static/media/userGrp.982c8519.svg";